// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2GhjA","productName":"Table_productName__2K7dp"};